import RestService from './RestService';

async function createInternalLink(req) {
	const res = await RestService.performRestOpNext(`authorizer/internal-link/create`, req);
	console.log(res);
	return res;
}

export default {
	createInternalLink
};
